import bgImage from './bg-current.png';

export const bgImg = {
    bg: bgImage
}